import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action, set } from "@ember/object"
import { join, later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import type AppState from "cc-frontend/services/app-state"
import type EmberStore from "cc-frontend/services/ember-store"
import styles from "./outline-and-detail.module.css"

@tagName("")
export default class Outline extends Component {
  readonly styles = styles
  // args
  focusedItemId
  canBeEditable
  isSelectable
  onNewFocusedItemId

  // state
  localFocusedItemId = null
  showEverything = false

  // services
  @service("ember-store") store!: EmberStore
  @service appState!: AppState

  didReceiveAttrs() {
    if (this.focusedItemId) {
      join(() => {
        set(this, "localFocusedItemId", this.focusedItemId)
      })
    }
  }

  didInsertElement() {
    // We do this because everything will wait to render until the outline...
    // which makes nothing appear on the screen for a second or two
    later(() => set(this, "showEverything", true), 1)
  }

  @action
  hasNewFocusedItemId(id) {
    this.onNewFocusedItemId(id)
  }
}
